import React from 'react';

const CommentFormatter = ({ value }: { value: string }) => {
  let comment: string = value ? value : '';
  // Limit comments to 50 characters for display on workspaces
  return comment.slice(0, 50);
};

export default CommentFormatter;
